import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import * as PropTypes from 'prop-types';
import { variant } from 'styled-system';

import { BaseBox } from '../../internal/components';
import { NavBarProps } from './types';

const StyledNavBar = styled(BaseBox)<NavBarProps>(
  css({
    bg: 'neutral.0',
    color: 'neutral.90',
    minHeight: '64px',
    borderBottomColor: 'neutral.50',
  }),
  variant({
    prop: 'type',
    variants: {
      branded: {
        bg: 'brandedHeaderBg',
        color: 'neutral.0',
      },
      prime: {
        bg: 'primary.90',
        color: 'neutral.0',
      },
    },
  }),
  variant({
    prop: 'effect',
    variants: {
      elevated: {
        boxShadow:
          '0px 0px 1px rgba(0, 0, 0, 0.4), 0px 2px 6px rgba(0, 0, 0, 0.1)',
      },
    },
  })
);

const NavBar = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof StyledNavBar>
>(({ type = 'default', effect = 'flat', ...rest }, ref) => (
  <StyledNavBar ref={ref} type={type} effect={effect} {...rest} />
));

NavBar.propTypes = {
  type: PropTypes.oneOf(['default', 'branded', 'prime']),
  effect: PropTypes.oneOf(['flat', 'elevated']),
};

export default NavBar;
